    export interface IPageNavigatorDirectiveScope extends ng.IScope {
        pageNavigatorDirective: PageNavigatorDirective;
        skip: number;
        take: number;
        count: number;
        showPagingOptions: boolean;
        pagingOptions: number[];
        navigateFn: () => any;
        navigateReverseFn: () => any;
        navigateFirstFn: () => any;
    }

    export class PageNavigatorDirective implements ng.IDirective {

        public restrict = 'E';
        public scope = {
            skip: '=',
            take: '=',
            count: '=',
            showPagingOptions: '=?',
            pagingOptions: '=?',
            navigateFn: '&',
            navigateReverseFn: '&',
            navigateFirstFn: '&?'
        };

        public template = require("./page-navigator-directive.html");

        private $timeout: angular.ITimeoutService;
        private $scope: IPageNavigatorDirectiveScope;

        public navigateFn: () => any;
        public navigateReverseFn: () => any;
        public navigateFirstFn: () => any;
        public currentPageNumber: number;

        public static $inject = ['$timeout'];
        constructor($timeout: angular.ITimeoutService) {
            this.$timeout = $timeout;
        }

        public link = ($scope: IPageNavigatorDirectiveScope, $elem: ng.IAugmentedJQuery): void => {
            $scope.pageNavigatorDirective = this;
            this.navigateFn = $scope.navigateFn;
            this.navigateReverseFn = $scope.navigateReverseFn;
            this.navigateFirstFn = $scope.navigateFirstFn;
            this.$scope = $scope;

            $scope.$watch('[skip,take,count]', (newvalue: any[], oldvalue: any[]) => {
                this.calculatePageNumber();
            });
        }

        public getFromCount = (): number => {
            return this.$scope.count === this.$scope.skip ? 0 : (this.$scope.skip + 1);
        }

        public getToCount = (): number => {
            return (this.$scope.skip + this.$scope.take) > this.$scope.count ? this.$scope.count : (this.$scope.skip + this.$scope.take);
        };

        public getPreviousClass = (): string => {
            return this.validPageNumber(this.currentPageNumber - 1) ? '' : 'disabled';
        }

        public getNextClass = (): string => {
            return this.validPageNumber(this.currentPageNumber + 1) ? '' : 'disabled';
        }

        public calculatePageNumber = (): void => {
            if (typeof this.$scope.take === 'undefined' || this.$scope.take == null || this.$scope.take === 0) return;
            this.currentPageNumber = (this.$scope.skip / this.$scope.take) + 1;
        };

        public validPageNumber = (pageNumber: number): boolean => {
            if (pageNumber < 1) return false;
            if (this.$scope.count <= ((pageNumber - 1) * this.$scope.take)) return false;
            return true;
        };

        public getLastPageNumber = (): number => {
            if (typeof this.$scope.take === 'undefined' || this.$scope.take == null || this.$scope.take === 0) return -1;
            if (typeof this.$scope.count === 'undefined' || this.$scope.count == null || this.$scope.count === 0) return -1;
            return Math.ceil(this.$scope.count / this.$scope.take);
        }

        public navigateToNextPage = (): void => {
            if (!this.validPageNumber(this.currentPageNumber + 1)) return;
            
            this.$timeout(() => {
                this.navigateFn();
            });
        };

        public navigateToPreviousPage = (): void => {
            if (!this.validPageNumber(this.currentPageNumber - 1)) return;
            
            this.$timeout(() => {
                this.navigateReverseFn();
            });
        };

        public navigateToFirstPage = (): void => {
            this.$timeout(() => {
                this.navigateFirstFn();
            });
        }
    }